"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var REGULAR = ['background: blue', 'color: white'].join(';');
var SUCCESS = ['background: green', 'color: white'].join(';');
var STARTED = ['background: darkorange', 'color: white'].join(';');
var FAILURE = ['background: red', 'color: white'].join(';');
var createLogger = function createLogger() {
  var active = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  return function (store) {
    return function (next) {
      return function (action) {
        if (!active) {
          return next(action);
        }
        var prevState = store.getState();
        var result = next(action);
        var nextState = store.getState();
        logGroupCollapsed("%c ".concat(action.type, " "), determineStyle(action));
        logInfo('%cprev state', 'color: darkorange', prevState);
        logInfo('%caction payload', 'color: blue', action.payload);
        logInfo('%cnext state', 'color: darkgreen', nextState);
        logGroupEnd();
        return result;
      };
    };
  };
};
var _default = exports.default = createLogger;
function logGroupCollapsed() {
  var logFunction = typeof function () {} === 'function' ? function () {} : function () {};
  logFunction.apply(void 0, arguments);
}
function logGroupEnd() {
  var logFunction = typeof function () {} === 'function' ? function () {} : function () {};
  logFunction.apply(void 0, arguments);
}
function logInfo() {
  var _console;
  (_console = console).info.apply(_console, arguments);
}
function determineStyle(action) {
  if (!action.meta || !action.meta.async) {
    return REGULAR;
  }
  if (action.type.indexOf('_COMPLETED') > -1) {
    return SUCCESS;
  }
  if (action.type.indexOf('_FAILED') > -1) {
    return FAILURE;
  }
  return STARTED;
}